import { ContentArticleReader as Modes0ContentArticleReader } from "@modes0/ui-components";
import { ContentBlock } from "@/types";

type ServiceContentRendererProps = {
  contentBlocks: ContentBlock[];
};

const ContentArticleReader = ({
  contentBlocks,
}: ServiceContentRendererProps) => (
  <Modes0ContentArticleReader
    contentBlocks={contentBlocks as never}
    paddingY="18px"
  />
);

export default ContentArticleReader;
